module.exports = __webpack_public_path__ + "img/social-twitter.cc85df8d.svg";